import { Settings2 } from "lucide-react";
import { useState } from "react";

import type { SavedTableColumnSettings, TableColumnAlignment, TableSettings, TableSettingsColumn } from "../lib/table-settings";

type Props = {
  columns: TableSettingsColumn[];
  settings: TableSettings;
  onChange: (key: string, update: Partial<SavedTableColumnSettings>) => void;
  onReset: () => void;
};

const alignmentLabels: Record<TableColumnAlignment, string> = {
  left: "Слева",
  center: "По центру",
  right: "Справа",
};

export function TableSettingsPanel({ columns, settings, onChange, onReset }: Props) {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedKey, setSelectedKey] = useState(columns[0]?.key ?? "");
  const column = columns.find((item) => item.key === selectedKey) ?? columns[0];
  if (!column) return null;
  const value = settings[column.key];
  const width = value.width ?? column.defaultWidth;

  return <div className="table-settings">
    <button className="icon-action table-settings-trigger" type="button" aria-label="Настройки таблицы" aria-expanded={isOpen} onClick={() => setIsOpen((open) => !open)}>
      <Settings2 size={17} />
    </button>
    {isOpen && <section className="table-settings-panel" aria-label="Настройки таблицы по месяцам">
      <label>Столбец
        <select value={column.key} onChange={(event) => setSelectedKey(event.target.value)}>
          {columns.map((item) => <option key={item.key} value={item.key}>{item.label}</option>)}
        </select>
      </label>
      <label>Ширина <output>{width} px</output>
        <input type="range" min={column.minWidth ?? 96} max={column.maxWidth ?? 480} value={width} onChange={(event) => onChange(column.key, { width: Number(event.target.value) })} />
      </label>
      <label>Выравнивание
        <select value={value.alignment} onChange={(event) => onChange(column.key, { alignment: event.target.value as TableColumnAlignment })}>
          {(Object.keys(alignmentLabels) as TableColumnAlignment[]).map((alignment) => <option key={alignment} value={alignment}>{alignmentLabels[alignment]}</option>)}
        </select>
      </label>
      <button className="secondary-button table-settings-reset" type="button" onClick={onReset}>Сбросить настройки</button>
    </section>}
  </div>;
}
